import styled from 'styled-components'

import { CircularProgress } from '../CircularProgress'
import { Fade } from '../Fade'
import type { ButtonWithIconProps } from './ButtonWithIcon'
import { ButtonWithIcon } from './ButtonWithIcon'
import { BUTTON_SIZE, ICON_SIZE } from './constant'

import { AsyncButtonLoadingStyles, LoadingIndicatorDiv, setLoadingColorsStyles } from './styles'

const StyledButton = styled(ButtonWithIcon)<{ $loading: boolean }>`
  ${setLoadingColorsStyles}
  ${AsyncButtonLoadingStyles}
`

export interface AsyncButtonWithIconProps extends ButtonWithIconProps {
  loading: boolean
}

export function AsyncButtonWithIcon({ loading, children, disabled, ...props }: AsyncButtonWithIconProps) {
  return (
    <StyledButton {...props} $loading={loading} disabled={disabled || loading}>
      <>
        <Fade in={loading} mountOnEnter unmountOnExit>
          <LoadingIndicatorDiv>
            <CircularProgress size={ICON_SIZE[props.size ?? BUTTON_SIZE.NORMAL]} color="inherit" />
          </LoadingIndicatorDiv>
        </Fade>
        <div>{children}</div>
      </>
    </StyledButton>
  )
}
